import React from 'react';

const Footer = () => {
  return (
    <footer className="py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-3 mb-4 md:mb-0">
            <svg className="w-10 h-10" viewBox="0 0 40 40" fill="none">
              <rect x="15" y="5" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="20" y="10" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="15" y="15" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="10" y="10" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="25" y="15" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="20" y="20" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="15" y="25" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="10" y="20" width="5" height="5" fill="#5B4FC7" rx="1"/>
              <rect x="5" y="15" width="5" height="5" fill="#5B4FC7" rx="1"/>
            </svg>
            <div>
              <div className="text-2xl font-bold" style={{color: '#2D2766'}}>RIC</div>
              <div className="text-xs font-medium" style={{color: '#5B4FC7'}}>Guiding You to Success</div>
            </div>
          </div>
          
          {/* Links */}
          <div className="flex space-x-6 text-gray-600">
            {/* <a href="#" className="hover:text-indigo-700 transition">Privacy Policy</a>
            <a href="#" className="hover:text-indigo-700 transition">Terms & Conditions</a>
            <a href="#" className="hover:text-indigo-700 transition">Refund Policy</a> */}
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 text-center text-gray-500 text-sm">
          © 2026 Royal Information Consultancy. All rights reserved. | Registered Visa & Immigration Consultants
        </div>
      </div>
    </footer>
  );
};

export default Footer;
